// export const URL = "http://68.183.203.61:8081";
export const URL = "https://dev-api.webtekstaging.com";
export const REACT_APP_URL = "https://app.rentdigicare.com/api";
export const REACT_APP_LOGIN_URL = "https://app.rentdigicare.com/login";
